<template>
  <div style="padding-top:30px;background-color:#FFFFFF">

  
   <div class="res" style="margin-top:100px;">
     <v-carousel 
     hide-delimiters
     :show-arrows="arrows"
     cycle="true">
    <v-carousel-item
    style="width: 100%;height: 100%;"
    
      v-for="(item,i) in items"
      :key="i"
      
    ><img style="width:100%;height: 100%;" :src="item.src" /></v-carousel-item>
  </v-carousel>
    </div>
    <div class="man man-phone" style="margin-top:50px;">
      <carousel :autoplay="true"      :show-arrows="arrows"
:items="1" :nav="false" >
        <img  src="../../assets/Banner/1.jpg" style="width: 100%" />
        <img  src="../../assets/Banner/2.jpg" style="width: 100%" />
        <img  src="../../assets/Banner/3.jpg" style="width: 100%" />
        <img  src="../../assets/Banner/newbanner1.jpeg" style="width: 100%" />
        <img  src="../../assets/Banner/newbanner2.jpeg" style="width: 100%" />
        <img  src="../../assets/Banner/newbanner3.jpeg" style="width: 100%" />

      </carousel>

  
    </div>
    <v-container style="justify-content: center;">
      <v-card class="res" style=" max-width:800px; background-color:#F1EEEE;border-left:7px solid;border-color:#ea0202;margin-top:-540px;margin-left:200px;">
      <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap >
       <v-flex xs12 sm12 md3 style="padding-right:5px;margin-top:10px;">
         <v-autocomplete
          append-icon="public"
          outlined
          v-model="selectedCountry"
          :items="countries"
          persistent-hint
          return-object
          single-line
          color="red"
          label="Select Country"
          item-text="countryName"
          item-value="id"
          @change="getType()"
          style="background-color:white;height:56px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="padding-right:5px;margin-top:10px;">
         <v-autocomplete
          append-icon="layers"
          outlined
          v-model="selectedCourse"
          :items="courses"
          persistent-hint
          return-object
          single-line
          color="red"
          label="Select Course"
          item-text="courseName"
          item-value="id"
          @change="getType()"
           style="background-color:white;height:56px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="padding-right:5px;margin-top:10px;">
         <v-autocomplete
          append-icon="category"
          outlined
          v-model="selectedType"
          :items="types"
          persistent-hint
          return-object
          single-line
          color="red"
          label="Select Course Type"
          item-text="typeName"
          item-value="id"
           style="background-color:white;height:56px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="text-align:center">
        <v-btn @click="searchBtn()" style="margin-top:15px;" dark color="#ea0202" depressed large block><v-icon>search</v-icon>
          <span class="mytxt">SEARCH NOW</span>
        </v-btn>
       </v-flex>
      </v-layout>
      </v-form>
      </v-container>
      
      </v-card>
      <v-card class="man" style=" max-width:800px; background-color:#F1EEEE;border-left:7px solid;border-color:#ea0202;">
      <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap >
       <v-flex xs12 sm12 md3 style="padding-right:5px;margin-top:10px;">
         <v-autocomplete
          append-icon="public"
          outlined
          v-model="selectedCountry"
          :items="countries"
          persistent-hint
          return-object
          single-line
          color="red"
          label="Select Country"
          item-text="countryName"
          item-value="id"
          @change="getType()"
          style="background-color:white;height:56px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="padding-right:5px;margin-top:10px;">
         <v-autocomplete
          append-icon="layers"
          outlined
          v-model="selectedCourse"
          :items="courses"
          persistent-hint
          return-object
          single-line
          color="red"
          label="Select Course"
          item-text="courseName"
          item-value="id"
          @change="getType()"
           style="background-color:white;height:56px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="padding-right:5px;margin-top:10px;">
         <v-autocomplete
          append-icon="category"
          outlined
          v-model="selectedType"
          :items="types"
          persistent-hint
          return-object
          single-line
          color="red"
          label="Select Course Type"
          item-text="typeName"
          item-value="id"
           style="background-color:white;height:56px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="text-align:center">
        <v-btn @click="searchBtn()" style="margin-top:15px;" dark color="#ea0202" depressed large block><v-icon>search</v-icon>
          <span class="mytxt">SEARCH NOW</span>
        </v-btn>
       </v-flex>
      </v-layout>
      </v-form>
      </v-container>
      
      </v-card>

      <!-- <v-card class="man" style="background-color:#F1EEEE;border-left:7px solid;border-color:#ea0202;margin-top:-590px;">
      <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
       <v-flex xs12 sm12 md3 style="padding-bottom:10px;">
         <v-autocomplete
          append-icon="public"
          outline
          v-model="selectedCountry"
          :items="countries"
          color="red"
          label="Select Country"
          item-text="countries"
          item-value="countries"
           style="background-color:white;height:58px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="padding-bottom:10px;">
         <v-autocomplete
          append-icon="layers"
          outline
          v-model="selectedLevel"
          :items="levels"
          color="red"
          label="Select Level"
          item-text="countries"
          item-value="countries"
           style="background-color:white;height:58px"
         ></v-autocomplete>
       </v-flex>
       <v-flex xs12 sm12 md3 style="padding-bottom:10px;">
         <v-text-field color="red" outline style="background-color:white;height:58px" v-model="form.courseName" label="Enter Course Name" ></v-text-field>
       </v-flex>
       <v-flex xs12 sm12 md3 style="text-align:center">
         <v-btn dark color="#ea0202" depressed large block><v-icon>search</v-icon>SEARCH NOW</v-btn>
       </v-flex>
      </v-layout>
      </v-form>
      </v-container>
      
      </v-card> -->
    </v-container >

    
      <div style="text-align:center;background-color:white; " class="res">
        <h1 class="mytxt">The Counse<span class="btn-gradient-1 mytxt">lling Process</span></h1>
        <p style="font-size:17px;padding-top:15px;" class="mytxt">Professional-Streamlined-Simple</p>
      </div>
      <v-container class="res" style="max-width:1250px">
        <div class="row" style="padding-top:30px;">
        <div class="col" style="text-align:center;">
          <img class="center hello" src="../../assets/communication.png" style="height:90px;width:90px;padding:10px;" />
          <p style="font-size:15px;" class="mytxt">Counselling & Documentation</p>
          <span class="hello1 mytxt">1</span>
        </div>
        <div class="col" style="text-align:center;">
          <span class="hello1 mytxt">2</span>
          <p style="font-size:15px;padding-top:20px;" class="mytxt">Course,University, Country Selection</p>
          <img class="center hello" src="../../assets/online-learning.png" style="height:90px;width:90px;padding:15px;" />
        </div>
        <div class="col" style="text-align:center;">
          <img class="center hello" src="../../assets/checklist.png" style="height:90px;width:90px;padding:15px;" />
          <p style="font-size:15px;" class="mytxt">Test <br>Preparation</p>
          <span class="hello1 mytxt">3</span>
        </div>
        <div class="col" style="text-align:center;">
          <span class="hello1 mytxt">4</span>
          <p style="font-size:15px;padding-top:20px;" class="mytxt">CV / SOP <br>Editing</p>
          <img class="center hello2" src="../../assets/resume.png" style="height:90px;width:90px;padding:15px;" />
        </div>
        <div class="col" style="text-align:center;">
          <img class="center hello" src="../../assets/submit.png" style="height:90px;width:90px;padding:15px;" />
          <p style="font-size:15px;" class="mytxt">Application Submission</p>
          <span class="hello1 mytxt">5</span>
        </div>
        <div class="col" style="text-align:center;">
          <span class="hello1 mytxt">6</span>
          <p style="font-size:15px;padding-top:20px;" class="mytxt">Offer Letter <br>Acceptance </p>
          <img class="center hello2" src="../../assets/job-offer.png" style="height:90px;width:90px;padding:15px;" />
        </div>
        <div class="col" style="text-align:center;">
          <img class="center hello" src="../../assets/mortarboard.png" style="height:90px;width:90px;padding:15px;" />
          <p style="font-size:15px;" class="mytxt">Payment & Loan assistance</p>
          <span class="hello1 mytxt">7</span>
        </div>
        <div class="col" style="text-align:center;">
          <span class="hello1 mytxt">8</span>
          <p style="font-size:15px;padding-top:20px;" class="mytxt">VISA Application Guide</p>
          <img class="center hello2" src="../../assets/visa.png" style="height:90px;width:90px;padding:15px;" />
        </div>
        <div class="col" style="text-align:center;">
          <img class="center hello" src="../../assets/departures.png" style="height:90px;width:90px;padding:15px;" />
          <p style="font-size:15px;" class="mytxt">Pre-departure briefing</p>
          <span class="hello1 mytxt">9</span>
        </div>
      </div>
      </v-container>
<div>
<v-container class="man mytxt">
        <h3 style="text-align:center;">The Counse<span class="btn-gradient-1">lling Process</span></h3>
        <p style="text-align:center;font-size:17px;">Professional-Streamlined-Simple</p>
        <carousel :autoplay="true" :items="1" :nav="false" >

<v-layout flat style="padding-top:20px;">
  <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >1</span><br/>
<img class="center hello" src="../../assets/communication.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">Counselling and Document Submission</p>
<v-divider></v-divider>
</v-flex>
</v-layout>

<v-layout>
    <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >2</span><br/>
<img class="center hello" src="../../assets/online-learning.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">Course and University Selection</p>
<v-divider></v-divider>
</v-flex>
  </v-layout>

  <v-layout>
    <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >3</span><br/>
<img class="center hello" src="../../assets/checklist.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">Test Preparation</p>
<v-divider></v-divider>
</v-flex>
  </v-layout>


<v-card>
<v-layout>
  <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >4</span><br/>
<img class="center hello" src="../../assets/resume.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">CV / SOP Editing</p>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-card>


<v-card>
<v-layout>
  <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >5</span><br/>
<img class="center hello" src="../../assets/submit.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">Application Submission</p>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-card>


<v-card>
<v-layout>
  <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >6</span><br/>
<img class="center hello" src="../../assets/job-offer.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">Offer Letter Acceptance </p>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-card>

<v-card>
<v-layout>
  <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >7</span><br/>
<img class="center hello" src="../../assets/mortarboard.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">Payment & Loan assistance</p>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-card>


<v-card>
<v-layout>
  <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >8</span><br/>
<img class="center hello" src="../../assets/resume.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">VISA Document and Interview Preparation</p>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-card>

<v-card>
<v-layout>
  <v-flex xs12 sm12 md2 style="text-align:center;padding:20px;">
<span class="hello1" >9</span><br/>
<img class="center hello" src="../../assets/departures.png" style="height:90px;width:90px;padding:10px;margin-top: 15px;" />
<p style="font-size:20px;">VISA Medical (if required)</p>
<v-divider></v-divider>
</v-flex>
</v-layout>
</v-card>



</carousel>

    </v-container>
  </div>
<!-- <v-layout row wrap>
  <v-flex xs12 style="text-align:center;padding-top:50px;padding-bottom:40px;">
    <h1>What We Offer</h1>
    <p style="font-size:17px;">These are the services that we provide</p>
  </v-flex>
</v-layout> -->
<!-- <div class="row">
    <div class="col kolkata test">
      <h3 style="padding-top:100px;">Test Preparation</h3>
      <p class="txt" style="padding-top:60px;text-align:justify;padding-left:10px;">
        We provide the best training for IELTS, TOEFL, PTE, GMAT, GRE, SAT and ACT. 
        Every student is unique and we follow a mentoring model where every student 
        is given personal attention. Our batch size is 
        small and our faculty ensures that the students perform to the best of their ability.</p>
        <v-btn depressed color="#303030" dark>Read More</v-btn>
    </div>
    <div class="col kolkata1 test">
      <h3 style="padding-top:100px;">Career Counseling</h3>
      <p class="txt" style="padding-top:60px;text-align:justify;">
        We guide you through a maze of questions to find solutions best suited to your 
        profile ensuring you choose the 
        best academic path to achieve your career goals based on your aptitude, ability and interest.</p>
        <v-btn depressed color="#303030" style="margin-top:87px;" dark>Read More</v-btn>
    </div>
    <div class="col kolkata3 test">
      <h3 style="padding-top:100px;">Finance & Scholarship</h3>
      <p class="txt" style="padding-top:60px;text-align:justify;">
        We give complete guidance on Educational Loans offered by Financial 
        Institute and Banks. We also provide information 
        to students about the various International, Institutional and National scholarships.</p>
        <v-btn depressed color="#303030" style="margin-top:35px;" dark>Read More</v-btn>
    </div>
    <div class="col kolkata4 test">
      <h3 style="padding-top:100px;">Admission Guidance</h3>
      <p class="txt" style="padding-top:60px;text-align:justify;">
        We give special attention to your application whether it is 
        paper based or online. We see to it that your required documents are thoroughly compiled, attested, 
        highlighting the areas essential for a well presented error free application.</p>
        <v-btn depressed color="#303030" style="margin-top:43px;" dark>Read More</v-btn>
    </div>
    <div class="col kolkata5 test">
      <h3 style="padding-top:100px;padding-right:10px;">Popular Courses</h3>
      <p class="txt" style="padding-top:60px;text-align:justify;padding-right:10px;">
        Popular courses vary from country to country. 
        We assist in identifying what are the industry trends and guide you in 
        subject selection based on parameters of skills required in the industry. 
        We also help to identify the correct institutions for these popular courses.</p>
        <v-btn depressed color="#303030" style="margin-top:25px;" dark>Read More</v-btn>
    </div>
</div> -->

<!-- <div>
  <v-container>
    <h1 style="padding-top:70px;padding-bottom:50px;" class="mytxt">What W<span class="btn-gradient-1 mytxt">e Offer</span></h1>
    <v-card flat>
    <v-tabs centered icons-and-text vertical>
      <v-tab style="width:500px;height:90px;">
        <h5 class="mytxt">Test Treparation</h5>
        <v-icon left :size="30" style="padding-top:15px;">assignment_add</v-icon>
      </v-tab>
      <v-tab style="width:500px;height:90px;">
        <h5 class="mytxt">Career Counseling</h5>
        <v-icon left :size="30" style="padding-top:15px;">psychology</v-icon>
      </v-tab>
      <v-tab style="width:500px;height:90px;">
        <h5 class="mytxt">Finance & Scholarship</h5>
        <v-icon left :size="30" style="padding-top:15px;">stacked_bar_chart</v-icon>
      </v-tab>
      <v-tab style="width:500px;height:90px;">
        <h5 class="mytxt">Admission Guidance</h5>
        <v-icon left :size="30" style="padding-top:15px;">book_online</v-icon>
      </v-tab>
      <v-tab style="width:500px;height:90px;">
        <h5 class="mytxt">Popular Courses</h5>
        <v-icon left :size="30" style="padding-top:15px;">gavel</v-icon>
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <v-layout row wrap>
            <v-flex xs12 sm12 md8>
              <img style="display:block;margin:auto;height: 450px;width:100%;" src="https://thumbs.dreamstime.com/b/hispanic-teen-girl-school-student-using-laptop-elearning-online-young-ethnic-college-computer-writing-pc-working-home-184027827.jpg" />
            </v-flex>
            <v-flex xs12 sm12 md4>
              <div style="height:450px;width:100%;background-color:#EA0202;;color: whitesmoke;">
                <p style="text-align:center;padding:15px;font-size:17px;padding-top: 100px;" class="mytxt" v-html="testDescription"></p>
                <div style="text-align:right">
                  <v-btn depressed color="#303030" @click="testP()" dark ><span class="mytxt">Read More</span></v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-layout row wrap>
            <v-flex xs12 sm12 md8>
              <img style="display:block;margin:auto;height: 450px;width:100%;" src="https://gyanvitaranammag.com/backend/assets/article_image/career.png" />
            </v-flex>
            <v-flex xs12 sm12 md4>
              <div style="height:450px;width:100%;background-color:#EE8600;">
                <p style="text-align:center;padding:15px;font-size:17px;padding-top: 100px;" class="mytxt">
                  We guide you through a maze of questions to find solutions best suited to your profile 
                ensuring you choose 
                the best academic path to achieve your career goals based on your aptitude, ability and interest.
                </p>
                <div style="text-align:right">
                  <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-layout row wrap>
            <v-flex xs12 sm12 md8>
              <img style="display:block;margin:auto;height: 450px;width:100%;" src="https://media.istockphoto.com/vectors/education-money-loan-credit-concept-or-scholarship-graduate-cost-vector-id1268153679?k=20&m=1268153679&s=612x612&w=0&h=39hPOI6IrjXuehHI09vXdFRjuvDuK1xFa6ke8wQtNrk=" />
            </v-flex>
            <v-flex xs12 sm12 md4>
              <div style="height:450px;width:100%;background-color:#EA0202;color: whitesmoke;">
                <p style="text-align:center;padding:15px;font-size:17px;padding-top: 100px;" class="mytxt">
                  We give complete guidance on Educational Loans offered by Financial Institute and Banks. We also provide information to students about the various International, Institutional and National scholarships.
                </p>
                <div style="text-align:right">
                  <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-layout row wrap>
            <v-flex xs12 sm12 md8>
              <img style="display:block;margin:auto;height: 450px;width:100%;" src="https://admissionblock.com/wp-content/uploads/2020/03/bba.png" />
            </v-flex>
            <v-flex xs12 sm12 md4>
              <div style="height:450px;width:100%;background-color:#EE8600;">
                <p style="text-align:center;padding:15px;font-size:17px;padding-top: 100px;" class="mytxt">
                  We give special attention to your application whether it is paper based or online. We see to it that your required documents are thoroughly compiled, attested, highlighting the areas essential for a well presented error free application.
                </p>
                <div style="text-align:right">
                  <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-layout row wrap>
            <v-flex xs12 sm12 md8>
              <img style="display:block;margin:auto;height: 450px;width:100%;" src="https://leverageedu.com/blog/wp-content/uploads/2019/09/Skill-Development-Courses.jpg" />
            </v-flex>
            <v-flex xs12 sm12 md4>
              <div style="height:450px;width:100%;background-color:#EA0202;color: whitesmoke;">
                <p style="text-align:center;padding:15px;font-size:17px;padding-top: 100px;" class="mytxt">
                  Popular courses vary from country to country. We assist in identifying what are the industry trends and guide you in subject selection based on parameters of skills required in the industry. We also help to identify the correct institutions for these popular courses.
                </p>
                <div style="text-align:right">
                  <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
    </v-tabs>
    </v-card>
  </v-container>
</div> -->

    <!-- <div style="background-color:#e2e0e0">
      <v-container>
      <v-layout row wrap style="padding-top:50px;">
        <v-flex xs12 sm12 md8>
          <h1 class="mytxt">What W<span class="btn-gradient-1 mytxt">e Offer</span></h1> -->
          <!-- <div class="row" style="margin:0px">
            <div class="col-lg-4 col-md-4 col-sm-12" style="height:150px">
              <img style="height:100%;width:100%" :src=testSrc />
            </div>
            <div @click="testBtn()" class="col-lg-8 col-md-8 col-sm-12" style="height:150px;background-color:#1561B2;color:whitesmoke;cursor:pointer;">
              <div class="container">
                <h3>Test Preparation</h3>
                <p style="text-align:justify;" v-html="testDescription"></p>
              </div>
            </div>
          </div>
          <div class="row" style="margin:0px;padding-top:15px;">
            <div @click="careerBtn()" class="col-lg-8 col-md-8 col-sm-12" style="height:150px;background-color:#E57900;cursor:pointer;">
              <div class="container">
                <h3>Career Counselling</h3>
                <p style="text-align:justify;" v-html="careerDescription"></p>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-12" style="height:150px">
              <img style="height:100%;width:100%" :src=careerSrc />
            </div>
          </div>
          <div class="row" style="margin:0px;padding-top:15px;">
            <div class="col-lg-4 col-md-4 col-sm-12" style="height:150px">
              <img style="height:100%;width:100%" :src=financeSrc />
            </div>
            <div @click="financeBtn()" class="col-lg-8 col-md-8 col-sm-12" style="height:150px;background-color:#1561B2;color:whitesmoke;cursor:pointer;">
              <div class="container">
                <h3>Finance & Scholarship</h3>
                <p style="text-align:justify;" v-html="financeDescription"></p>
              </div>
            </div>
          </div> -->
          <!-- <v-layout row wrap style="padding-top:20px;" class="mytxt">
            <v-flex xs12 sm12 md5 style="color:whitesmoke;background-color:#184679;padding-bottom:20px;">
              <h3 style="padding:15px;padding-top:25px;" class="mytxt">Test Preparation</h3>
              <p style="text-align:justify;padding:15px;font-size:13px;" class="mytxt" v-html="testDescription"></p>
              <v-btn depressed color="#303030" dark @click="testP()"><span class="mytxt">Read More</span></v-btn>
            </v-flex>
            <v-flex xs12 sm12 md7 style="background-image:url('https://thumbs.dreamstime.com/b/hispanic-teen-girl-school-student-using-laptop-elearning-online-young-ethnic-college-computer-writing-pc-working-home-184027827.jpg')" class="img1" >
            </v-flex>
            <v-flex xs12 sm12 md7 class="img1" style="background-image:url('https://gyanvitaranammag.com/backend/assets/article_image/career.png')" >
            </v-flex>
            <v-flex xs12 sm12 md5 style="color:whitesmoke;background-color:#E68200;">
              <h3 style="padding:15px;padding-top:25px;" class="mytxt">Career Counseling</h3>
              <p style="text-align:justify;padding:15px;font-size:13px;" class="mytxt">
                We guide you through a maze of questions to find solutions best suited to your profile 
                ensuring you choose 
                the best academic path to achieve your career goals based on your aptitude, ability and interest.
              </p>
              <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
            </v-flex>
            <v-flex xs12 sm12 md5 style="color:whitesmoke;background-color:#184679;padding-bottom:20px;">
              <h3 style="padding:15px;padding-top:25px;" class="mytxt">Finance & Scholarship</h3>
              <p style="text-align:justify;padding:15px;font-size:13px;" class="mytxt">
                We give complete guidance on Educational Loans offered by Financial 
                Institute and Banks. We also provide 
                information to students about the various International, Institutional and National scholarships.
              </p>
              <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
            </v-flex>
            <v-flex xs12 sm12 md7 style="background-image:url('https://media.istockphoto.com/vectors/education-money-loan-credit-concept-or-scholarship-graduate-cost-vector-id1268153679?k=20&m=1268153679&s=612x612&w=0&h=39hPOI6IrjXuehHI09vXdFRjuvDuK1xFa6ke8wQtNrk=')" class="img1" >
            </v-flex>
            <v-flex xs12 sm12 md7 class="img1" style="background-image:url('https://admissionblock.com/wp-content/uploads/2020/03/bba.png')" >
            </v-flex>
            <v-flex xs12 sm12 md5 style="color:whitesmoke;background-color:#E68200;">
              <h3 style="padding:15px;padding-top:25px;" class="mytxt">Admission Guidance</h3>
              <p style="text-align:justify;padding:15px;font-size:13px;" class="mytxt">
                We give special attention to your application whether it is paper based or online. 
                We see to it that your required documents are thoroughly compiled, 
                attested, highlighting the areas essential for a well presented error free application.
              </p>
              <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
            </v-flex>
            <v-flex xs12 sm12 md5 style="color:whitesmoke;background-color:#184679;padding-bottom:20px;">
              <h3 style="padding:15px;padding-top:25px;" class="mytxt">Popular Courses</h3>
              <p style="text-align:justify;padding:15px;font-size:13px;" class="mytxt">
                Popular courses vary from country to country. We assist in identifying what are the 
                industry trends and guide you in subject selection based on parameters of skills 
                required in the industry. We also help to identify the correct institutions for these 
                popular courses.
              </p>
              <v-btn depressed color="#303030" dark><span class="mytxt">Read More</span></v-btn>
            </v-flex>
            <v-flex xs12 sm12 md7 style="background-image:url('https://leverageedu.com/blog/wp-content/uploads/2019/09/Skill-Development-Courses.jpg')" class="img1" >
            </v-flex>
          </v-layout>
        </v-flex> -->

        <!-- <v-flex xs12 md4 style="height:550px" v-if="universitynews.length>0">
          <h3 style="padding-left:40px;color:#1561b2" class="mytxt">UNIVERSITY NEWS</h3>
          <v-divider style="padding-left:40px;color:#1561b2"></v-divider>
                  <marquee direction = "down" onMouseOver="this.stop()" onMouseOut="this.start()">
                    <v-card flat class="form-container" v-for="item in universitynews" :key="item.id" style="background-color:white;padding:10px;margin-bottom:10px;margin-top:0px;">
                
                 <v-card-title style="padding:0px;">
                   <v-avatar :size="100">
                             <img :src=item.src >
                           </v-avatar><br/>
                           <v-btn depressed color="#ED2020" dark>{{item.title}}</v-btn>
                           <p v-html="item.description"></p>
                            
                 </v-card-title>
                   </v-card>
                  </marquee>
        </v-flex>
      </v-layout>
    </v-container>
    </div> -->

<!-- ***************************** CARD ******************* -->
    <div class="" style="background-image: url(https://img.freepik.com/free-photo/gray-abstract-wireframe-technology-background_53876-101941.jpg?w=1380&t=st=1671442219~exp=1671442819~hmac=595292551af6e339a363a543b07aac571039b6bd50e4a40ab56626fb40538c9d) ;background-repeat: no-repeat;padding-top: 30px;margin-top: 50px;  background-size: cover;">
      <v-container>
        
        <h1 style="text-align:center;" class="mytxt">What W<span class="btn-gradient-1 mytxt">e Offer</span></h1>

      <v-layout row wrap style="padding-top:50px;">

<!-- **********************************CARD -----111111111111111111111 -->
<v-flex  lg4 xs12 sm12 md5 style="color:whitesmoke;">
          <template>
      <v-card
      :loading="loading"
          class="mx-auto my-12 p-0"
          max-width="374"
          elevation="16"
          height="550"
  >
              <template slot="progress">
                <v-progress-linear
                  color="#fff"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                height="250"
                src="https://gyanvitaranammag.com/backend/assets/article_image/career.png"
              ></v-img>

              <v-card-title class="p-3" style="font-size:22px" >Career Counseling</v-card-title>

              <v-card-text class="p-4" >
 


                <div >We guide you through a maze of questions to find solutions best suited to your profile ensuring you choose the best academic path to achieve your career goals based on your aptitude, ability and interest.</div>
              </v-card-text>


              <v-card-actions>
                <v-btn
                  color="#ea0202"
                  text
                  @click="careerBtn()"
                  
                >
                READ MORE
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-flex>
        <!-- ************************** CARD -------2222222222222222222222 -->

        <v-flex  lg4 xs12 sm12 md5 style="color:black;">
          <template>
      <v-card
          :loading="loading"
          class="mx-auto my-12 p-0"
          max-width="374"
          elevation="16"
          height="550"
        >
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                height="250"
                src="https://thumbs.dreamstime.com/b/hispanic-teen-girl-school-student-using-laptop-elearning-online-young-ethnic-college-computer-writing-pc-working-home-184027827.jpg'"
              ></v-img>
            
              <v-card-title class="p-3" style="font-size:22px"  >Test Preparation</v-card-title>

              <v-card-text class="p-4" >
 


                <div >Education abroad is not just about surfing the internet, filing the application forms and sending students to the universities of their choice. The admission to a foreign university is a multifario...</div>
              </v-card-text>


              <v-card-actions>

                <v-btn
                class="btn-more "
                  color="#ea0202"
                  text
                  @click="testP()"
                >
                READ MORE
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-flex>
  <!-- **********************************CARD ----- 33333333333333333333 -->

  <v-flex  lg4 xs12 sm12 md5 style="color:black;">
          <template>
      <v-card
          :loading="loading"
          class="mx-auto my-12 p-0"
          max-width="374"
          elevation="16"
          height="550"
 
        >
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                height="250"
                src="https://leverageedu.com/blog/wp-content/uploads/2019/09/Skill-Development-Courses.jpg"
              ></v-img>

              <v-card-title class="p-3" style="font-size:22px"  >Course Selection & Application</v-card-title>

              <v-card-text class="p-4" >

                <div >Popular courses vary from country to country. We assist in identifying what are the industry trends and guide you in subject selection based on parameters of skills required in the industry. We also help to identify the correct institutions for these popular courses.</div>
              </v-card-text>


              <v-card-actions>
                <v-btn
                  color="#ea0202"
                  text
                  @click="admissionBtn()"
                >
                READ MORE
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-flex>

<!-- **********************************CARD -----444444444444444444444444 -->
       <v-flex  lg4 xs12 sm12 md5 style="color:whitesmoke;">
          <template>
      <v-card
      :loading="loading"
          class="mx-auto my-12 p-0"
          max-width="374"
          elevation="16"
          height="550"
  >
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                height="250"
                src="https://img.freepik.com/premium-photo/graduation-gap-hat-us-dollar-banknotes-money-education-study-fee-learning-teach-concept_39768-7878.jpg?w=1380"
              ></v-img>

              <v-card-title class="p-3" style="font-size:22px;align-items: baseline;word-break: break-word; " > Financial / Education Loan Assistance</v-card-title>

              <v-card-text class="p-4"  >
 


                <div>We give complete guidance on Educational Loans offered by Financial Institute and Banks. We also provide information to students about the various International, Institutional and National scholarships.</div>
              </v-card-text>


              <v-card-actions>
                <v-btn
                  color="#ea0202"
                  text
                  @click="financeBtn()"
                >
                READ MORE
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-flex>
<!-- ***************************** CARD 5555555555555555555 ********************************** -->
        <v-flex  lg4 xs12 sm12 md5 style="color:black;">
          <template>
      <v-card
          :loading="loading"
          class="mx-auto my-12 p-0"
          max-width="374"
          elevation="16"
          height="550"
 
        >
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                height="250"
                src="https://images.pexels.com/photos/7235894/pexels-photo-7235894.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              ></v-img>

              <v-card-title class="p-3" style="font-size:22px"  >Visa & Forex Assistance</v-card-title>

              <v-card-text class="p-4" >

                <div >Popular courses vary from country to country. We assist in identifying what are the industry trends and guide you in subject selection based on parameters of skills required in the industry. We also help to identify the correct institutions for these popular courses.</div>
              </v-card-text>


              <v-card-actions>
                <v-btn
                  color="#ea0202"
                  text
                  @click="visaBtn()"
                >
                READ MORE
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-flex>

<!-- **********************************CARD -----6666666666666666666666666 -->

        <v-flex  lg4 xs12 sm12 md5 style="color:black;">
          <template>
      <v-card
          :loading="loading"
          class="mx-auto my-12 p-0"
          max-width="374"
          elevation="16"
          height="550"

        >
              <template slot="progress">
                <v-progress-linear
                  color="deep-purple"
                  height="10"
                  indeterminate
                ></v-progress-linear>
              </template>

              <v-img
                height="250"
                src="https://admissionblock.com/wp-content/uploads/2020/03/bba.png"
              ></v-img>

              <v-card-title class="p-3" style="font-size:22px"  >Accommodation & Travel</v-card-title>

              <v-card-text class="p-4" >
 


                <div >We give special attention to your application whether it is paper based or online. We see to it that your required documents are thoroughly compiled, attested, highlighting the areas essential for a well presented error free application.</div>
              </v-card-text>


              <v-card-actions>
                <v-btn
                  color="#ea0202"
                  text
                  @click="visaBtn()"
                >
                READ MORE
                </v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-flex>



      </v-layout>
    </v-container>
    </div>

<!-- ***************************** CARD END ******************* -->

<!-- ***************************** NEWS ******************* -->

<div>
<div >
  <v-container class="mytxt">
    <v-layout row wrap>
    <v-flex xs12 style="text-align:center;padding-top:50px;padding-bottom:40px;">
    <h1 class="mytxt">Univer<span class="btn-gradient-1 mytxt">sity News</span></h1>
  </v-flex>
    </v-layout>

  </v-container>
  <!-- v-for="item in universitynews" :key="item.id"
  v-if="universitynews.length > 0" -->
<!-- <v-container>
    <div class="res" > -->
        <!-- <v-card class="swo" style="margin-right:5px;margin-left:5px;margin-top:15px;"> -->
          <!-- <carousel :autoplay="true" :items="3" :nav="false" > -->

              <!-- <v-card  
                class="mx-auto"
                max-width="344"
                
              >
                <img
                  src="../../assets/Blogs/UH.jpeg"
                  height="200px"
                  style="border-radius:50px;"
                  cover
                />
                <v-card-title class="my-3">
                  University of Hertfordshire
                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;"  >
                  "The University of Hertfordshire offers a wide range of Undergraduate, Postgraduate,
                   Professional and Short courses. One of the top 150 universities in the world under 
                   50 years old and only 25 minutes from London."
                </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="UniversityDetails()" depressed 

                  >
                  
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>
              </v-card> -->
 <!-- ********************************** 22222222222222222222222222222 -->
              <!-- <v-card  
                class="mx-auto"
                max-width="344"
              >
                <img
                  src="../../assets/Blogs/UL.jpeg"
                  height="200px"
                  style="border-radius:50px;"
                  cover
                />
                <v-card-title class="my-3">
                  University of Leicester
                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;">
                  University of Leicester is open for September 2023, start applying Please note
                   that applications are open  for the University of Leicester for September 2023,
                    start applying ASAP to grab seats with scholarships up to 5000 GBP           
                       </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="UniversityDetails()"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>


                </v-card-actions>
              </v-card> -->

              <!-- **************************** CARD 33333333333333333333333333333 -->

              <!-- <v-card  
                class="mx-auto"
                max-width="344"
              >
                <img
                  src="../../assets/Blogs/Algoma University.jpeg"
                  height="200px"
                  style="border-radius:50px;"
                  cover
                />
                <v-card-title class="my-3">
                  Algoma University
                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;">
                  Algoma University, commonly shortened to Algoma U or Algoma, is a public 
                  university with its main campus located in Sault Ste. Marie, Ontario, Canada 
                               </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="UniversityDetails()"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>
              </v-card> -->

              <!-- *********************CARD 4444444444444444444444444444444444 -->
              <!-- <v-card  
                class="mx-auto"
                max-width="344"
              >
                <img
                  src="../../assets/Blogs/scholarship.jpeg"
                  height="200px"
                  style="border-radius:50px;"
                  cover
                />
                <v-card-title class="my-3">
                  Scholarship
                                </v-card-title>

                <v-card-subtitle style="text-align: justify; height: 150px;"  >
                  Many UK higher-education institutions offer their own scholarship programmes.
                   These are offered based on a number of factors, which can be broadly split out 
                   into the following categories: Academic, merit and excellence scholarships...
                    </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="UniversityDetails()"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>
              </v-card> -->
          <!-- </carousel> -->
          <!-- <div style="text-align:center;padding-top:15px;margin-top: 30px;">
            <v-btn @click="universityAll()" style="margin-bottom:10px;" depressed large outline color="#23527C">
              <span class="mytxt" style="color:whitesmoke;">View All Universities</span>
            </v-btn>
         </div> -->
        <!-- </v-card> -->
    <!-- </div>
  </v-container> -->
</div>
<v-container>
  <div class="res" v-if="universitynews.length > 0">
        <v-card class="swo" style="margin-right:5px;margin-left:5px;margin-top:15px;">
          <carousel :autoplay="true" :items="3" :nav="false" >
              <v-card
              v-for="item in universitynews" :key="item.id"
                class="mx-auto"
                
                max-width="344"
              >
                <v-img
                  :src= item.src
                  height="200px"
                  style="border-radius:50px;"
                  cover
                ></v-img>

                <v-card-title >
                  {{ item.title }}
                </v-card-title>

                <v-card-subtitle  v-html="item.description.slice(0, 150)">
                  
                </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="onUni(item)"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>

            
              </v-card>
 

          </carousel>
        </v-card>
  </div>
</v-container>
    <div class="man" v-if="universitynews.length > 0">
        <!-- <v-card class="swo" style="margin-right:5px;margin-left:5px;margin-top:15px;"> -->
          <carousel :autoplay="true" :items="1" :nav="false" >
              <v-card
              v-for="item in universitynews" :key="item.id"
                class="mx-auto"
                
                max-width="344"
              >
                <v-img
                  :src= item.src
                  height="200px"
                  style="border-radius:50px;"
                  cover
                ></v-img>

                <v-card-title >
                  {{ item.title }}
                </v-card-title>

                <v-card-subtitle  v-html="item.description.slice(0, 150)">
                  
                </v-card-subtitle>

                <v-card-actions>
                  <v-btn
                    color="orange-lighten-2"
                    variant="text"
                    @click="onUni(item)"
                  >
                    Explore
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn
                    :icon="show ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    @click="show = !show"
                  ></v-btn>
                </v-card-actions>

            
              </v-card>
 

          </carousel>
        <!-- </v-card> -->
    </div>
</div>





    <!-- ================================= Products Categories =================================== -->


<div>
  <v-container class="mytxt">
    <v-layout row wrap>
    <v-flex xs12 style="text-align:center;padding-top:50px;padding-bottom:40px;">
     <h1 class="mytxt mobile-heading">Choose Y<span class="btn-gradient-1 mytxt">our Country</span></h1>
  </v-flex>
    </v-layout>

  </v-container>



  
    <div class="res" v-if="featuredCountries.length > 0">
        <!-- <v-card class="swo" style="margin-right:5px;margin-left:5px;margin-top:15px;"> -->
          <carousel :autoplay="true" :items="7" :nav="false">
            <v-card @click="onCountry(owl)" v-for="owl in featuredCountries" :key="owl.id" :style="{backgroundImage: `url(${owl.image})`}" class="tourtheme hvr">
              <img :src="owl.src" style="border-radius:50%;height:50px;width:50px;" />
              <h5 class="mytxt" style="background-color:#bb0000;color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 135px;">{{owl.countryName}}</h5>
            </v-card>
          </carousel>
        <!-- </v-card> -->
    </div>

    <div class="man" v-if="featuredCountries.length > 0">
        <!-- <v-card class="swo" style="margin-right:5px;margin-left:5px;margin-top:15px;"> -->
          <carousel :autoplay="true" :items="1" :nav="false" :dots="false">
            <v-card @click="onCountry(owl)" v-for="owl in featuredCountries" :key="owl.id" :style="{backgroundImage: `url(${owl.image})`}" class="tourtheme hvr">
              <img :src="owl.src" style="border-radius:50%;height:50px;width:50px;" />
              <h5 class="mytxt" style="background-color:#bb0000;color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 135px;">{{owl.countryName}}</h5>
            </v-card>
          </carousel>
        <!-- </v-card> -->
    </div>
    <!-- <div class="row" v-if="featuredCountries.length>0">
      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12" style="margin-bottom:25px;" v-for="item in featuredCountries" :key="item.id">
            <div class="location-block">
              <div class="location-img zoomimg"> <a href="#" class="text-white"> <img :src=item.src alt="" class="img-fluid"> </a>
                <div class="location-img-overlay d-flex justify-content-between ">
                  <h3 class="pt-1 mb-0"><a href="" class="text-white">Study in {{item.countryName}}</a></h3>
                </div>
              </div>
            </div>
          </div>
    </div> -->
    <div style="text-align:center;margin-bottom: 50px;margin-top: 30px;">
      <v-btn @click="countryAll()" style="margin-bottom:10px;" depressed large outline color="#23527C">
        <span class="mytxt" style="color:whitesmoke;">View All Countries</span>
      </v-btn>
    </div>
  
</div>
<!-- ************************************************************************** INFO FORM **********************************************-->
<div class="about-us-img" style="background-image: url('https://apicms.worldwin.co.in/welcomeimage/files/info-bg.png') ;background-repeat: no-repeat;background-size: cover; padding-top: 100px;padding-bottom: 150px;">

<v-container>
    <v-layout row wrap>
        <v-flex xs12 sm12 md6 class="m-2"  style="display:flex;flex-direction: column; justify-content: flex-end;" >
           <div  style="color:#ffffff; padding: 20px;">
            <h1>READY TO <br>GET STARTED?</h1>
              <p>Fill in the window alongside.<br>Register to connect and hear from us!</p>
          </div></v-flex>
        <v-flex xs12 sm12 md6>
            <v-card flat elevation="14">
   
                <v-container v-if="otp==false">
                  <v-form ref="form" v-model="valid" lazy-validation>  
                    <v-layout row wrap style="padding:40px;margin-top:-30px;">
                    <v-flex xs12>
                        <h1 style="text-align:center;padding-top:5px;" class="txt">Request <strong>Information</strong> </h1>
                    </v-flex>

                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                        <v-text-field v-model="myform.name" label="Name *" :rules="emptyRule" required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md6 >
                        <v-text-field v-model="myform.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                    </v-flex>
                    <v-flex xs12  style="padding-top:-10px!important" >
                        <v-text-field v-model="myform.subject" label="Mobile Number *" :rules="[rules.mobileno]" required></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 >
                        <v-textarea v-model="myform.msg" label="Your Message *" :rules="emptyRule" required></v-textarea>
                    </v-flex> -->
                    <v-flex xs12 md6 style="padding-right:5px; padding-bottom:20px" >
                      <v-autocomplete
                                   v-model="selectedQualification"
                                   :items="courses1"
                                   color="primary"
                                   label="Last Qualification *"
                                   item-text="courses1"
                                   item-value="courses1"
                                  ></v-autocomplete>
                     </v-flex>
                      <v-flex xs12 md6 style=" padding-bottom:20px" >
                        <v-autocomplete
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Country Interested In *"
                                   item-text="countryName"
                                   item-value="countryName"
                                  ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6 style="padding-right:5px;padding-bottom: 20px;" >
                        <v-autocomplete
                                   v-model="selectedIntake"
                                   :items="intake"
                                   color="primary"
                                   label="Select Upcoming Intake *"
                                   item-text="intake"
                                   item-value="intake"
                                  ></v-autocomplete>
                     </v-flex>
                      <v-flex xs12 md6 style=" padding-bottom:20px" >
                        <v-autocomplete
                                   v-model="selectedCourse"
                                   :items="courses1"
                                   color="primary"
                                   label="Courses Interested In *"
                                   item-text="courses1"
                                   item-value="courses1"
                                  ></v-autocomplete>
                      </v-flex>
                    <v-flex xs12 style="padding-bottom:12px;text-align:center;" >
                      <b-form-checkbox v-model="status"> Accept Wordlwin <span @click="termdialog=true" class="hvr" style="color:#0061bc;">Terms & Conditions</span> and <span @click="privacydialog=true" class="hvr" style="color:#0061bc;">Privacy Policy</span></b-form-checkbox>
                    </v-flex>
                    <v-flex xs12 >
                        <v-btn style="border-radius:50px" dark :loading="btnSave" depressed color="#EA0202" large block @click="getOtp()">Register Now</v-btn>
                    </v-flex>
                </v-layout>
                  </v-form>
                </v-container>

                <v-container v-if="otp==true">
                  <div style="text-align:right;padding:5px;">
                   <v-icon :size="25" @click="back()">close</v-icon>
                  </div>
                  <v-form ref="form1" v-model="valid" lazy-validation>  
                    <v-layout row wrap style="padding:50px;margin-top:-30px;">
                    <v-flex xs12>
                        <h3 style="text-align:center;padding-top:5px;font-weight:bold" class="txt">Verify Your mobile number</h3>
                    </v-flex>

                    <v-flex xs12 sm12 md12 style="padding-right:5px">
                        <v-text-field v-model="form1.otp" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                    </v-flex>
                    <v-flex xs12 >
                        <v-btn style="border-radius:50px" dark :loading="btnSave1" depressed color="#EA0202" large block @click="onSubmit()">Vefity Now</v-btn>
                    </v-flex>
                </v-layout>
                  </v-form>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</div>
<!-- ****************************************************************           INFO end ******************************************** -->
<!-- ************************************************************************* BLOGS & ARTICLES ***************************************** -->
<div style="background-image: url(https://img.freepik.com/free-photo/gray-abstract-wireframe-technology-background_53876-101941.jpg?w=1380&t=st=1671442219~exp=1671442819~hmac=595292551af6e339a363a543b07aac571039b6bd50e4a40ab56626fb40538c9d) ;background-repeat: no-repeat;padding-top: 50px; background-size: cover; ">

<div style="margin-top:20px;">
    <!-- ================================= Products Categories =================================== -->

 <v-container>

      <v-layout row wrap >

        <v-flex xs12 sm12 md4 style="padding:80px;" class="res">

          <h1 class="mytxt mobile-heading">Blogs And Articles</h1>
          <p class="mytxt" style="font-size:17px;padding-top:10px;">The latest education trends, news and more</p>
       
          <div style="padding-top:15px;">
             <v-btn 
             @click="blogsAll()" style="margin-bottom:10px;" depressed large outline color="#23527C">
            <span class="mytxt" style="color:whitesmoke;">View All Blogs</span>
            </v-btn>
           </div>
           
          <!-- <v-layout row wrap style="padding-top:20px;" >
          </v-layout> -->
        </v-flex>

        <v-flex xs12 sm12 md4 style="padding:50px;" class="man">

        <h1 class="mytxt mobile-heading">Blogs And Articles</h1>
        <p class="mytxt" style="font-size:17px;padding-top:10px;">A community of lifelong learners, responsible global citizens, and champions of our own success</p>

        <div style="padding-top:15px;">
          <v-btn 
          @click="blogsAll()" style="margin-bottom:10px;" depressed large outline color="#23527C">
          <span class="mytxt" style="color:whitesmoke;">View All Blogs</span>
          </v-btn>
        </div>
        
        <!-- <v-layout row wrap style="padding-top:20px;" >
        </v-layout> -->
        </v-flex>

        <v-flex xs12 sm12 md8 v-if="blogs.length > 0 " class="res">

          <carousel :autoplay="true" :items="2" :nav="false" >

                <template>
                  <v-card
                    class="mx-auto"
                    max-width="350"
                     height="500px"
                    xs6 sm12 md3 v-for="item in blogs" :key="item.id"
                    style="padding: 0px ; margin-right: 15px;"
                  >
                    <v-img
                    :src=item.src         
                     height="200px"
                      cover
                    ></v-img>

                    <v-card-title style="padding: 20px; height: 80px;align-items: baseline;word-break: break-word;"  >
                      {{item.title}}
                    </v-card-title>

                    <v-card-text  class="p-4" v-html="item.description.slice(0, 150)" style="text-align:justify;" >
                
              </v-card-text>

                    <v-card-actions>
                      <v-btn
                class="btn-more "
                  color="#ea0202"
                  text
                  @click="blg(item)"
                >
                READ MORE
                </v-btn>



                    </v-card-actions>

                  </v-card>
                </template>

          </carousel>

        </v-flex>
  <v-flex xs12 sm12 md8 v-if="blogs.length > 0 " class="man">

<carousel :autoplay="true" :items="1" :nav="false" >

      <template>
        <v-card
          class="mx-auto"
          max-width="350"
           height="500px"
          xs6 sm12 md3 v-for="item in blogs" :key="item.id"
          style="padding: 0px ; margin-right: 15px;"
        >
          <v-img
          :src=item.src         
           height="200px"
            cover
          ></v-img>

          <v-card-title style="padding: 20px; height: 80px;align-items: baseline;word-break: break-word;"  >
            {{item.title}}
          </v-card-title>

          <v-card-text  class="p-4" v-html="item.description.slice(0, 150)" style="text-align:justify;" >
      
    </v-card-text>

          <v-card-actions>
            <v-btn
      class="btn-more "
        color="#ea0202"
        text
        @click="blg(item)"
      >
      READ MORE
      </v-btn>



          </v-card-actions>

        </v-card>
      </template>

</carousel>

</v-flex>
      </v-layout>

 </v-container>
    </div>
  <!-- <div class="res" v-if="featuredCountries.length > 0">
        <v-card class="swo" style="margin-right:5px;margin-left:5px;margin-top:15px;">
          <carousel :dots="false" :autoplay="true" :items="3" :nav="false">
            <div v-for="owl in featuredCountries" :key="owl.id" class="tourtheme1" @click="category(owl)">
              <div class="row">
                <div class="col-7">
                  <h5 style="margin-top:15px;padding-left: 10px;" class="mytxt">What is Lorem Ipsum?</h5>
                </div>
                <div class="col-5">
                  <div style="margin-top:15px;"><img class="center" :src="owl.src" style="height:70px;width:100px;" /></div>
                </div>
                <div class="col-12">
                  <p class="mytxt" style="padding:10px;color:grey">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the 
                    industry's standard dummy text ever since the 
                    1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.  
                  </p>
                  <p class="mytxt" style="padding:10px;color:grey">• Study Abroad Guidance</p>
                </div>
              </div>
            </div>
          </carousel>
        </v-card>
    </div> -->
  <!-- <v-container>
  <v-layout row wrap style="padding-top:70px;padding-bottom:70px;">
    <v-flex xs12 sm12 md4 v-for="item in blogs" :key="item.id">
      <v-card
      style="padding:0px;height:510px;"
    class="mx-auto my-12"
    max-width="374"
  >
    <v-img
      height="250"
      :src=item.src
    ></v-img>

    <h4 style="padding:10px;color:#2557B5;" class="mytxt">{{item.title}}</h4>

    <v-card-text>

      <div style="text-align:justify;color:grey;" class="mytxt" v-html="item.description" ></div>
    </v-card-text>

      <div style="text-align:right" class="sub_div">
        <v-btn
      class="mx-2"
      fab
      small
      depressed
      dark
      color="#1877F2"
    >
      <v-icon dark>
        share
      </v-icon>
    </v-btn>
        <v-btn
        color="#484848"
        text
        dark
        @click="blg(item)"
      >
        <span class="mytxt">Read More</span>
      </v-btn>
      </div>
  </v-card>
    </v-flex>
</v-layout>
  </v-container> -->
</div>

<div>
  <v-layout row wrap>
    <v-flex xs12 style="text-align:center;padding-top:50px;padding-bottom:40px;">
    <h1 class="mytxt mobile-heading">Our Studen<span class="btn-gradient-1 mytxt">t Studying in</span></h1>
  </v-flex>
    </v-layout>
    <div class="row" v-if="featuredUniversities.length>0">
      <div class="col">
        <marquee>
          <img v-for="item in featuredUniversities" :key="item.id" style="padding:25px; margin-right: 10px; height:50px; width:120px" :src=item.src />
        </marquee>
      </div>
    </div>
    <div style="text-align:center;padding-top:15px;">
      <v-btn @click="universityAll()" style="margin-bottom:20px;" depressed large outline color="#23527C">
        <span class="mytxt" style="color:whitesmoke;">View All Universities</span>
      </v-btn>
    </div>
</div>

<div v-if="galleries.length>0" style="background-image: url(https://img.freepik.com/free-photo/gray-abstract-wireframe-technology-background_53876-101941.jpg?w=1380&t=st=1671442219~exp=1671442819~hmac=595292551af6e339a363a543b07aac571039b6bd50e4a40ab56626fb40538c9d) ;background-repeat: no-repeat;padding-top: 50px; background-size: cover; ">
<div class="container">
  <h1  style="margin-bottom:20px; padding-top:10px; text-align: left;" class="mytxt mobile-heading">Gal<span class="btn-gradient-1 mytxt">lery</span></h1>
  <v-layout row wrap>
    <v-flex xs12 sm12 md3 v-for="item in galleries" :key="item.id">
      <v-card class="mx-auto">
          <v-img
          :src=item.src         
           height="200px"
            cover
          ></v-img>
        </v-card>
    </v-flex>
  </v-layout>

  <div style="padding-top:25px;text-align: center;">
             <v-btn 
             @click="galleryAll()" style="margin-bottom:10px;" depressed large outline color="#23527C">
            <span class="mytxt" style="color:whitesmoke;">View All Gallery</span>
            </v-btn>
           </div>
</div>
</div>




<!-- <div style="background-color:#e2e0e0">
  <v-container>
  <v-layout row wrap>
    <v-flex xs12 style="text-align:center;padding-top:50px;padding-bottom:40px;">
    <p class="mytxt" style="font-size:17px;padding-top:10px;">A community of lifelong learners, responsible global citizens, and champions of our own success</p>
  </v-flex>
    <v-flex xs12 sm12 md7>
        <carousel :autoplay="true" :items="1" :nav="false" v-if="items3.length>0">
            <div v-for="owl in items3" :key="owl.id">
              <v-card style="background-color:#fcb232;border-radius:0px;height:412px;">
                <v-container>
                  <v-container>
                  <h3 class="mytxt" style="color:#23527C;">{{owl.title}}</h3>
                <v-divider></v-divider>
                <h4 class="mytxt">{{owl.sub}}</h4>
                <p style="text-align:justify;padding-top:20px;" v-html="owl.description" class="mytxt"></p>
                <div style="text-align:right">
                  <v-btn @click="newsBtn(owl)" color="#23527C" dark><span class="mytxt">Read More</span></v-btn>
                </div>
                </v-container>
                </v-container>
              </v-card>
            </div>
          </carousel>
    </v-flex>
    <v-flex xs12 sm12 md5 v-if="events.length==4">
      <div class="grid-container">
  <div class="grid-item item1">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[0])" >
            <v-img
              :src=events[0].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="200px"
              width="100%"
            >
              <v-card-title style="color:whitesmoke;" class="mytxt">{{events[0].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
  <div class="grid-item item2">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[1])">
            <v-img
              :src=events[1].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="410px"
              width="100%"
            >
              <v-card-title style="color:whitesmoke;" class="mytxt">{{events[1].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
  <div class="grid-item item3">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[2])">
            <v-img
              :src=events[2].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="200px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[2].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>  
  <div class="grid-item item4">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[3])">
            <v-img
              :src=events[3].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="200px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[3].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
</div>
      
    </v-flex>
    <v-flex xs12 sm12 md5 v-if="events.length==3">
      <div class="grid-container">
  <div class="grid-item item1">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[0])" >
            <v-img
              :src=events[0].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="200px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[0].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
  <div class="grid-item item2">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[1])">
            <v-img
              :src=events[1].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="410px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[1].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
  <div class="grid-item item3">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[2])">
            <v-img
              :src=events[2].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="200px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[2].title}}</v-card-title>
            </v-img>
      </v-card>
  </div> 
</div>
      
    </v-flex>
    <v-flex xs12 sm12 md5 v-if="events.length==2">
      <div class="grid-container">
  <div class="grid-item item1">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[0])" >
            <v-img
              :src=events[0].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="200px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[0].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
  <div class="grid-item item2">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[1])">
            <v-img
              :src=events[1].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="410px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[1].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
</div>
      
    </v-flex>
    <v-flex xs12 sm12 md5 v-if="events.length==1">
      <div class="grid-container">
  <div class="grid-item item1">
    <v-card class="mshvr" style="padding:0px;border-radius:0px;cursor:pointer;" @click="newsBtn(events[0])" >
            <v-img
              :src=events[0].src
              class="align-end"
              gradient="to bottom, rgba(0,0,0,.6), rgba(0,0,0,.7)"
              height="200px"
              width="100%"
            >
              <v-card-title class="mytxt" style="color:whitesmoke;">{{events[0].title}}</v-card-title>
            </v-img>
      </v-card>
  </div>
</div>
      
    </v-flex>
  </v-layout>
  <div style="text-align:center">
    <v-btn @click="newsAll()" style="margin-bottom:10px;" depressed large outline color="#23527C">
      <span class="mytxt" style="color:whitesmoke;">View All News & Events</span>
    </v-btn>
  </div>
</v-container>
</div> -->

<div class="kolkata6 ">  
  <h1  style="margin-bottom:20px; padding-top:20px; text-align: center;" class="mytxt mobile-heading">Studen<span class="btn-gradient-1 mytxt">t Testimonial</span></h1>

    <v-layout row wrap>

      <v-flex xs12 sm12 md7 style="padding:25px">
        <div class="container" style="padding-top:25px;">

          <div class="row">
            <div class="col-lg-6 col-md-6" style="text-align: center;padding-bottom: 15px;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/t9geaUKy5vI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-lg-6 col-md-6" style="text-align: center;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/RADBic9ne_M" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-lg-6 col-md-6" style="text-align: center;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/OHNoqW3gVcs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-lg-6 col-md-6" style="text-align: center;">
              <iframe width="330" height="180" src="https://www.youtube.com/embed/gnHwF1J4xJ4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <!-- <v-container>
         <v-carousel 
         :continuous="false"
      :cycle="false"
      :show-arrows="false"
      hide-delimiter-background
      height="300"
      >
    <v-carousel-item v-for="(item,i) in items2" :key="i">
      <video-embed :src=item.src ></video-embed>
    </v-carousel-item>
  </v-carousel>
        </v-container> -->
      </v-flex>


      <v-flex xs12 sm12 md5 style="padding:25px ;">
        <v-container v-if="items1.length>0" >

         <carousel :autoplay="true" :items="1" :nav="false">
            <div v-for="owl in items1" :key="owl.id">
              <p style="color:white;font-size:16px;font-weight: 300;" v-html="owl.description" class="mytxt"></p>
              <v-card-title style="justify-content:center" >
              
                  <img style="height:80px;width:80px; border-radius:50px" :src=owl.src />
               &nbsp;&nbsp; <h4 style="color:white;margin-top:30px">{{owl.name}}
                  <p style="color:#FDC800;font-size:16px ;margin-top:10px;" class="mytxt">({{owl.address}})</p>
                  <p style="color:white;font-size:16px ;margin-top:0px" class="mytxt">{{owl.courseName}}</p>

                </h4>

              </v-card-title>

              <div style=" display: flex;justify-content: space-around;">
                <div>
                  <img style="height:60px;width:120px; margin: auto;"  :src=owl.countrySrc />
                  <p class="mytxt" style="margin-top:10px;">{{owl.countryName}}</p>
                </div>

               <div>
                <img style="height:60px;width:120px;margin: auto;" :src=owl.universitySrc />       
                <p class="mytxt" style="margin-top:10px;">{{ owl.universityName }}</p>
               </div>

              </div>
      
             
              
              
            </div>
          </carousel>
        </v-container>
      </v-flex>
    </v-layout>

    <div style="text-align:center;padding-top:15px;padding-bottom:15px;">
      <v-btn @click="testimonialAll()" depressed large outline color="white">
        <span class="mytxt">View All Testimonials</span>
      </v-btn>
    </div>
  </div>
      
  <v-dialog v-model="dialog1" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>

     <v-dialog v-model="galleryDialog" width="700px">
      <v-card v-if="galleries1.length>0">
        <v-carousel :autoplay="false" :items="1" show-arrows="hover" :hide-delimiters="true" :nav="false">
          <v-carousel-item
            v-for="(item,i) in galleries1"
            :key="i"
            :src="item.src"
            cover
          ></v-carousel-item>
        </v-carousel>
      </v-card>
      
     </v-dialog>
  </div>
</template>
<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
import moment from 'moment';
//import VueEasyLightbox from 'vue-easy-lightbox';
//import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    //GoTop,
    carousel,
  },
  metaInfo: {
    title: 'Default App Title',
    titleTemplate: '%s | vue-meta Example App',
    htmlAttrs: {
      lang: 'en-US'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', vmid: 'description', content: 'An example Vue application with vue-meta.' },
      { name: 'viewport', vmid: 'description1', content: 'width=device-width, initial-scale=1' }
    ]
  },
  data() {
    return {
      tab: null,
      text: "",
      valid: true,
      arrows: false,
      otp: false,
      valid: true,
      isLoading: false,
      galleryDialog: false,
      text: null,
      read: false,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      termdialog: false,
      privacydialog: false,
      galleries: [],
      galleries1: [],

      intake: ["Winter Intake (January - March)", "Mid  Intake (April - July)", "Main intake (September - November)"],
      selectedIntake: null,

      countries: [],
      selectedCountry: null,

      courses1: [],
      selectedCourse: null,
      selectedQualification: null,

      myform: {
          name: null,
          email: null,
          subject: null,
          msg: null
      },

      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },

      first: false,
      form: {
        courseName: null
      },

      items: [],
      events: [],

      blogs: [],

        items2: [
        ],

    items1: [],

    items3: [],
    dialog1: false,

    testSrc: null,
    testDescription: null,
    careerSrc: null,
    careerDescription: null,
    financeSrc: null,
    financeDescription: null,

    universitynews: [],

    featuredCountries: [],
    featuredUniversities: [],

      countries: [],
      selectedCountry: null,

      courses1: [],
      selectedCourse: null,

      types: [],
      selectedType: null
    };
  },
  
   mounted() {
     this.axios
      .get(config.API + `country/authors1`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.featuredCountries.push({
            id: element.id,
            countryName: element.countryName,
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
          })
        }
      });

      this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.countries = res.data.authors;
      });

      this.axios
      .get(`https://api.worldwin.org/api/Levels`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data;
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.courses1.push(element.levelName)
        }
      });

      this.axios
      .get(config.API + `servicetype/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;

        this.testSrc = config.API1 + "servicetype/files/" + list[2].src;
        this.testDescription = list[2].description.substring(0, 200) + '...';
        

        this.careerSrc = config.API1 + "servicetype/files/" + list[1].src;
        this.careerDescription = list[1].description.substring(0, 200) + '...';

        this.financeSrc = config.API1 + "servicetype/files/" + list[0].src;
        this.financeDescription = list[0].description.substring(0, 200) + '...';
      });

      this.axios
      .get(config.API + `university/authors1`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.featuredUniversities.push({
            id: element.id,
            universityName: element.universityName,
            src: config.API1 + "university/files/" + element.src
          })
        }
      });

      this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);
        this.countries = list;
      });

      this.axios
      .get(config.API + `course/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        this.courses = list;
      });

      this.axios
      .get(config.API + `news/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          if(element.newscategoryId==1) {
            this.items3.push({
              id: element.id, 
              title: element.title,
              description: element.description 
            })
          }
        }

        console.log(this.items3);
      });
      
     this.axios
      .get(config.API + `banner/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.items.push({
            id: element.id, 
            src: config.API1 + 'banner/files/' + element.src
          })
        }
      });

      this.axios
      .get(config.API + `gallery/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        
        for (let index = 0; index < 8; index++) {
          const element = list[index];
          
          this.galleries.push({
            id: element.id, 
            src: config.API1 + 'gallery/files/' + element.src
          })
        }
      });

      this.axios
      .get(config.API + `gallery/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;

        for (let index = 0; index < 8; index++) {
          const element = list[index];
          
          this.galleries1.push({
            id: element.id, 
            src: config.API1 + 'gallery/files/' + element.src
          })

          console.log(this.galleries1);
        }

      });

      this.axios
      .get(config.API + `blog/authors2`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          this.blogs.push({
            id: element.blog.id, 
            title: element.blog.title,
            description: element.blog.description,
            src: config.API1 + 'blog/files/' + element.src
          })
        }
      });

      this.axios
      .get(config.API + `testimonial/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);
        
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          if(element.type=='text') {
            this.items1.push({
            id: element.id, 
            name: element.name,
            address: element.address,
            description: element.description,
            courseName: element.course.courseName,
            universitySrc: config.API1 + 'university/files/' + element.university.src,
            countrySrc: config.API1 + 'country/files/' + element.university.country.src,
            countryName: element.university.country.countryName,
            universityName: element.university.universityName,
            src: config.API1 + 'testimonial/files/' + element.src
          })
          }
        }
      });

      this.axios
      .get(config.API + `news/authors2`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          if(element.news.newscategoryId==3) {
            this.universitynews.push({
            id: element.news.id, 
            title: element.news.title,
            description: element.news.description,
            src: config.API1 + 'news/files/' + element.src
            })
          }
        }
      });

      this.axios
      .get(config.API + `news/authors2`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        if(list.length>0) {
          for (let index = 0; index < list.length; index++) {
          const element = list[index];
          
          if(element.news.newscategoryId==2) {
            if(this.events.length < 4) {
              this.events.push({
              id: element.news.id, 
              title: element.news.title,
              src: config.API1 + "news/files/" + element.src
             })
            }
          }
        }
        }
        
      });

      
   },

 methods: {
   newsBtn(item) {
    this.$router.push("/newsDetail/" + item.id);
   },

   onUni(item) {
    this.$router.push("/university-details");
    sessionStorage.setItem("unisrc", item.src);
    sessionStorage.setItem("unititle", item.title);
    sessionStorage.setItem("unidescription", item.description);
   },

   getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.myform.name,
              email: this.myform.email,
              mobileNumber: JSON.parse(this.myform.subject),
              page: '(Home page) request information',
              course: null,
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.myform.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }

            let comment = "Last Qualification: " + this.selectedQualification + ", Preferred Country: " + this.selectedCountry + ", Selected Upcoming Intake: " + this.selectedIntake + ", Preferred Course: " + this.selectedCourse;
            console.log(comment);
            this.axios
          .post(
            `https://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.myform.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.myform.email,
              guardianName: null,
              guardianNo: 0,
              comment: comment,
              pageName: '(Home page) request information',
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog1 = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave = false;
          });
        /* this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.subject),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          }); */
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.$refs.myform.reset();
      this.dialog1 = false;
    },

   onCountry(item) {
    sessionStorage.setItem("countryName", item.countryName);
    sessionStorage.setItem("image", item.image);
    sessionStorage.setItem("banner", item.banner);
    sessionStorage.setItem("countryId", item.id); 
    ////this.$router.push("/countrydetail/" + item.id );
    if(item.countryName=='UK') {
      this.$router.push("/study-in-uk");
    }
    else if(item.countryName=='Dubai') {
      this.$router.push("/study-in-dubai");
    }
    else if(item.countryName=='Singapore') {
      this.$router.push("/study-in-singapore");
    }
    else if(item.countryName=='USA') {
      this.$router.push("/study-in-usa");
    }
    else if(item.countryName=='Australia') {
      this.$router.push("/study-in-australia");
    }
    else if(item.countryName=='Canada') {
      this.$router.push("/study-in-canada");
    }
   },

   testP() {
     this.$router.push("/test-preparation");
   },

   allCountry() {
     this.$router.push("/all-countries");
   },

   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },

   getType() {
     this.types = [];
     this.axios
          .post(
            config.API + `coursecountry/author1`,
            {
              countryId: JSON.parse(this.selectedCountry.id),
              courseId: JSON.parse(this.selectedCourse.id)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            let list = res.data.author;

            for (let index = 0; index < list.length; index++) {
              const element = list[index];
              
              this.types.push({
                id: element.coursetype.id,
                typeName: element.coursetype.typeName
              })
            }
          })
   },

   searchBtn() {
     if(this.selectedCountry != null && this.selectedCourse != null && this.selectedType != null) {
       sessionStorage.setItem('countryId', this.selectedCountry.id);
       sessionStorage.setItem('courseId', this.selectedCourse.id);
       sessionStorage.setItem('typeId', this.selectedType.id);

       sessionStorage.setItem('countryName', this.selectedCountry.countryName);
       sessionStorage.setItem('courseName', this.selectedCourse.courseName);
       sessionStorage.setItem('typeName', this.selectedType.typeName);

       this.$router.push("/search-university");
      }
      else {
       this.$toaster.error("Please select country, course & course type");
      }
    },

   newsAll() {
     this.$router.push("/news");
   },

   testimonialAll() {
     this.$router.push("/testimonial-list");
   },
   UniversityDetails() {
     this.$router.push("/university-details");
   },

   testBtn() {
     this.$router.push("/test-preparation");
   },

   careerBtn() {
     this.$router.push("/career-counselling");
   },

   countryAll() {
     this.$router.push("/all-countries");
   },
   blogsAll() {
     this.$router.push("/blog");
   },
   galleryAll() {
     /* this.$router.push("/gallery"); */
     this.galleryDialog=true;
   },
      testBtn() {
     this.$router.push("/test-preparation");
   },
      careerBtn() {
     this.$router.push("/career-counselling");
   }, 
      financeBtn() {
     this.$router.push("/financial-assistance");
   },
      admissionBtn() {
     this.$router.push("/course-application");
   },
      popularBtn() {
     this.$router.push("/test-preparation");
   },
      visaBtn() {
     this.$router.push("/travel-visa-forex");
   },
   universityAll() {
    this.$router.push("/university");
   }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Archivo+Black&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap'); 
</style>

<style scoped>
.btn-more {
  background-color:" #FF0000!important";
}
.mytxt {
  font-family: 'Roboto', sans-serif !important;
  /* font-weight: 200!important; */

}
.txt {
  font-family: 'Roboto', sans-serif !important;
  font-weight: 300;
}
.icon-bar {
  position: fixed;
  top: 55%;
  z-index: 1;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.grid-container {
  display: grid;
  grid-gap: 5px;
  background-color: whitesmoke;
  padding: 4px;
}

.grid-item {
}

.item1 {
  grid-column: 1 / span 2;
  grid-row: 1;
}

.item2 {
  grid-column: 3;
  grid-row: 1 / span 2;
}

.item5 {
  grid-column: 1 / span 3;
  grid-row: 3;
}

.kolkata {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('../../assets/test_preparation.jpg');
    background-size: cover;
    text-align: center;
    color: white !important;
    height: 550px;
}
.kolkata1 {
    background-image: linear-gradient(to bottom,rgba(221, 114, 42, 0.73), rgba(54, 34, 20, 0.73)), url('../../assets/career_counselling.jpeg');
    background-size: cover;
    text-align: center;
    color: white !important;
    height: 550px;
}
.kolkata3 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('../../assets/scholarship.png');
    background-size: cover;
    text-align: center;
    color: white !important;
    height: 550px;
}
.kolkata4 {
    background-image: linear-gradient(to bottom,rgba(221, 114, 42, 0.73), rgba(22, 20, 54, 0.73)), url('../../assets/admission.jpg');
    background-size: cover;
    text-align: center;
    color: white !important;
    height: 550px;
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('../../assets/popular_course.jpg');
    background-size: cover;
    text-align: center;
    color: white !important;
    height: 550px;
}
.kolkata6 {
    background-image: linear-gradient(to left,rgba(12, 0, 0, 0.73), rgba(221, 148, 52, 0.73)), url('https://www.manavguru.org/wp-content/uploads/2021/03/Turm-Condition-Banner-1920-x-530.jpg');
    background-size: cover;
    color: white !important;
}
.featured {
  background-image: linear-gradient(to left,rgba(12, 0, 0, 0.73), rgba(221, 148, 52, 0.73));
  background-size: cover;
  color: white !important;
}
/* .test:after {
  background-image: url('../../assets/bgimage.jpg') !important;
  transition: 1s all;   
} */

.test:hover {
  background-image: linear-gradient(to bottom,rgba(15, 2, 2, 0.73), rgba(15, 2, 2, 0.73)), url('../../assets/bgimage.jpg') !important;
  background-size: cover;
  transition-delay: 5s !important; 
}
.mycarousel {
  width: 100% !important;
  min-width: 100% !important;
}
.vtbs  {
  padding: 0px !important;
}

.img1 {
  background-size: cover;
  height: 300px;
}

/* Style the icon bar links */
.icon-bar a {
  display: block;
  text-align: center;
  padding: 16px;
  transition: all 0.3s ease;
  color: white;
  font-size: 20px;
}
.facebook {
  background: #3B5998;
  color: white;
}
.hello {
    background-color: #EA0202;
    border: 5px solid white;
    border-radius: 50px;
    width: 100px;
    height: 100px;
    -webkit-animation: color_change 1s infinite alternate;
    -moz-animation: color_change 1s infinite alternate;
    -ms-animation: color_change 1s infinite alternate;
    -o-animation: color_change 1s infinite alternate;
    animation: color_change 1s infinite alternate;
}
.hello2 {
    background-color: #E58100;
    border: 1px solid white;
    border-radius: 50px;
    width: 100px;
    height: 100px;
    -webkit-animation: color_change 1s infinite alternate;
    -moz-animation: color_change 1s infinite alternate;
    -ms-animation: color_change 1s infinite alternate;
    -o-animation: color_change 1s infinite alternate;
    animation: color_change 1s infinite alternate;
}
.hello1 {
    border: 1px solid black;
    background-color: rgb(243, 240, 240);
    border-radius: 50px;
    font-size: 30px;
    padding: 15px;
    text-align: center;
}
@-webkit-keyframes color_change {
	from { background-color: #EA0202; }
	to { background-color: #E58100; }
}
@-moz-keyframes color_change {
	from { background-color: #EA0202; }
	to { background-color: #E58100; }
}
@-ms-keyframes color_change {
	from { background-color: #EA0202; }
	to { background-color: #E58100; }
}
@-o-keyframes color_change {
	from { background-color: #EA0202; }
	to { background-color: #E58100; }
}
@keyframes color_change {
	from { background-color: #EA0202; }
	to { background-color: #E58100; }
}
.sub_div {
                position: absolute;
                bottom: 0px;
                text-align: right !important;
            }

.twitter {
  background: #55ACEE;
  color: white;
}

.google {
  background: #dd4b39;
  color: white;
}

.linkedin {
  background: #007bb5;
  color: white;
}

.youtube {
  background: #bb0000;
  color: white;
}
.v-tabs__container--fixed-tabs .v-tabs__div, .v-tabs__container--icons-and-text .v-tabs__div {
    min-width: 0px !important;
}
.banner1 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/1');
  background-size: contain;

  height:450px;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.btn-gradient-1 {
  border-bottom: 5px solid;
  border-image: linear-gradient(to right, #EA0202, #E58100) 1;
}

.banner {
  background-image: url('../../assets/bgimage.jpg');
  background-size: cover;
  height: 450px !important;
}
.banner2 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/2');
  background-size: contain;

  height:450px;
}
.text_dec {
  text-decoration: none !important;
  height: 5px;
  color: #EA0202;
}
.banner3 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/4');
  background-size: contain;

  height:450px;
}
.banner4 {
  background-image: url('https://csquad.infosyst.in/api/BannerImage/3');
  background-size: contain;

  height:450px;
}
.bannertxt {
  font-family: 'Archivo Black', sans-serif;;
}
/* .banner {
  background-image: url('https://www.anstro.co.za/wp-content/uploads/2017/08/Anstro-Catering-Equipment-Slide1-1030x332.jpg');
  background-size: cover;

  height:550px;
} */
.txt_dec:hover {
  text-decoration: none !important;
}
.hvr:hover {
  text-decoration: none !important;
}
.wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.v-card {
  padding: 10px;
  border-radius: 7px;
  
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.mshvr:hover {
  opacity: 0.7;
}
.swo {
  box-shadow: none !important;
}
.prdt {
  background-size: cover;
}
.prdt1 {
  background-size: cover;
  height: auto;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 220px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 130%;
}

.tourtheme1 {
  border-right: 0.5px solid;
  border-top: 0.5px solid;
  border-bottom: 0.5px solid;
  border-color: #bbb;
  background-color: white;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}

.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.res{
  padding-top: 5px;
   padding-bottom: 15px;
}
.salont {
  font-family: 'Patua One', cursive;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
.mobile-heading {
  font-size: 30px;
}
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 11%;
  top: 0%;
}
.srch1 {
  position: absolute;
  z-index: 10;
  left: 11%;
  top: 0%;
}
.flip-box {
  background-color: transparent;
  width: 300px;
  height: 200px;
  border: 1px solid #f1f1f1;
  perspective: 1000px;
}

.flip-box-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.8s;
  transform-style: preserve-3d;
}

.flip-box:hover .flip-box-inner {
  transform: rotateY(180deg);
}

.flip-box-front, .flip-box-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-box-front {
  background-color: #bbb;
  color: black;
}

.flip-box-back {
  transform: rotateY(180deg);
}

@keyframes zoominoutsinglefeatured {
    0% {
        transform: scale(1,1);
    }
    50% {
        transform: scale(1.2,1.2);
    }
    100% {
        transform: scale(1,1);
    }
}

.cardcontainer img {
    animation: zoominoutsinglefeatured 1s infinite ;
}
.track {
  background-image: url('../../assets/track.jpg');
  background-size: cover;
  height: 300px;
  margin: 25px;
}
.subscribe {
  background-image: url('https://assets.weforum.org/project/image/FQuygXPMd2A4O0deuG3gXRCqpEng4BdwvO3kMkn6Aoo.jpeg');
  background-size: cover;
  height: auto;
  margin: 25px;
}
.track1 {
  background-color: #F3F3F3 !important;
  background-size: cover;
  height: 300px;
  margin: 25px;
}
.ordr:hover {
  background-color: #166be0 !important;
}
.news {
    text-align: center;
    font-weight: bold;
    font-size: 40px;
    padding-top: 50px;
    background: linear-gradient(to right,#3F51B5 10%,#3F51B5 40%,#00668C 70%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
.fade:hover {
  visibility: visible;
    animation-name: medizinAnimationFadeInUp;
}

.mydiv {
  transition: height 0.5s ease-out 100ms;
}

.mydiv:hover {
  height: 100px;
  cursor: pointer;
}
.bck {
  background-image: linear-gradient(to right, #7bf3f3 , transparent) !important;
}
.myimg {
  transition: height 0.5s ease-out 100ms;
}

.myimg:hover {
  cursor: pointer;
}
.hide {
  display: none;
}

.myDIV:hover + .hide {
  display: inline-block !important;
}

.zoomimg {
    position: relative;
    overflow: hidden;
}
.location-img {
    position: relative;
}
.location-img:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0px;
    width: 100%;
    opacity: .9;
    background-image: -webkit-linear-gradient(top, currentColor, transparent);
    background-image: linear-gradient(0deg, currentColor 0, transparent);
    color: #000000;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    opacity: .6;
    height: 100%;
}
.text-white {
    color: #fff!important;
}
a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
}
.zoomimg img {
    max-width: 100%;
    -moz-transition: all 0.3s;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    float: left;
    width: 100%;
}
.img-fluid {
    max-width: 100%;
    height: 200px;
}
.location-img-overlay {
    position: absolute;
    bottom: 15px;
    width: 100%;
    padding: 0px 20px;
}
.justify-content-between {
    -ms-flex-pack: justify!important;
    justify-content: space-between!important;
}
.d-flex {
    display: -ms-flexbox!important;
    display: flex!important;
}
.pt-1, .py-1 {
    padding-top: .25rem!important;
}
.mb-0, .my-0 {
    margin-bottom: 0!important;
}
.location-img-overlay h3 a {
    font-size: 20px;
}

.img-hover-zoom {
  height: 300px; /* [1.1] Set it as per your need */
  overflow: hidden; /* [1.2] Hide the overflowing of child elements */
}

/* [2] Transition property for smooth transformation of images */
.img-hover-zoom img {
  transition: transform .5s ease;
}

/* [3] Finally, transforming the image when container gets hovered */
.img-hover-zoom:hover img {
  transform: scale(1.5);
}
</style>
